import { render, staticRenderFns } from "./FleeingGoodsList.vue?vue&type=template&id=120649ba&scoped=true"
import script from "./FleeingGoodsList.vue?vue&type=script&lang=js"
export * from "./FleeingGoodsList.vue?vue&type=script&lang=js"
import style0 from "./FleeingGoodsList.vue?vue&type=style&index=0&id=120649ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120649ba",
  null
  
)

export default component.exports